<template>
  <footer class="footer">
    <div class="container">
      <!-- Row Start -->
      <div class="row">
        <div class="col-md-8 col-sm-8">
          <div class="row">
            <div class="col-md-4 col-sm-4">
              <img src="/img/acca-logo-pc-01.svg" width="100" class="logo logo-scrolled" alt="">
            </div>
            <div class="col-md-4 col-sm-4 resp">
              <h4>{{ $t('footer.category') }}</h4>
              <ul>
                <li v-for="f in functions.slice(0, 7)"><a href="javascript:void(0)" @click="goJobs(f.functions_ids)">{{ $i18n.locale === 'zh' ? f.c_name : f.e_name }}</a></li>
              </ul>
            </div>
            <div class="col-md-4 col-sm-4 resp">
              <h4>&nbsp;</h4>
              <ul>
                <li v-for="f in functions.slice(7)"><a href="javascript:void(0)" @click="goJobs(f.functions_ids)">{{ $i18n.locale === 'zh' ? f.c_name : f.e_name }}</a></li>
              </ul>
            </div>
            
          </div>
        </div>
        
        <div class="col-md-4 col-sm-4">
          <h4>{{ $t('footer.careers') }}</h4>            
          <ul>
            <li class="resp"><router-link to="/jobs">{{ $t('footer.search') }}</router-link></li>
            <li><a href="javascript:void(0)" data-toggle="modal" data-target="#subscribe">{{ $t('footer.subscribe') }}</a></li>
            <li class="resp"><router-link to="/jobs?featured=1">{{ $t('footer.featured') }}</router-link></li>
            <li class="resp"><router-link to="/blogs">职场建议</router-link></li>
            <li><a href="javascript:void(0)" data-toggle="modal" data-target="#followus">{{ $t('footer.hire') }}</a></li>
            <li><a href="https://www.accacnjobs.com/#/terms-jobseeker.html" target="_blank">{{ $t('footer.terms') }}</a></li>
            <li><a href="https://www.accacnjobs.com/#/policy.html" target="_blank">{{ $t('footer.privacy') }}</a></li>
            <li><a href="https://www.accacnjobs.com/#/terms-recruiter.html" target="_blank">招聘单位用户服务协议</a></li>
            <li class="resp"><router-link to="/contact">{{ $t('footer.contact') }}</router-link></li>
          </ul>
        </div>
      </div>
      <!-- Row Start -->
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>&copy; {{ $t('nav.footer') }} <br> <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备15017467号-2</a></p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<style>
@media only screen and (max-width:480px) {
  .resp {
    display: none;
  }
}
</style>
<script>
import moment from 'moment'
  
export default {
  name: 'Footer',
  props: ['functions'],
  data: () => ({
  }),
  computed: {
    thisYear: function() {
      return moment().year()
    }
  },
  methods: {
    goJobs: function(fid) {
      this.$router.push({
          path: '/jobs',
          query: {
            functions_id: fid.join(',')
          }
        })
    }
  },
  created: function() {
    
  }
}
</script>